import Slider from '../utils/web-components/slider';

export default class HowToUse extends Slider {
  constructor() {
    super();

    this.totalContentCount = parseInt(
      this.getAttribute('total-content-count'),
      10,
    );
    this.shouldMobileCenterSlides = this.getAttribute(
      'should-mobile-center-slides',
    );
    this.hideSwiperUntilUpdate = this.hasAttribute('hide-swiper-until-update');
  }

  connectedCallback() {
    super.connectedCallback();
    this.updateSwiperParams({
      spaceBetween: 20,
      slidesPerView: 1.3,
      centeredSlides: this.shouldMobileCenterSlides === 'true',
      centeredSlidesBounds: this.shouldMobileCenterSlides === 'true',
      breakpoints: {
        1024: {
          centeredSlides: false,
          centeredSlidesBounds: false,
          slidesPerView: this.totalContentCount,
          spaceBetween: 30,
        },
      },
    });
    if (this.hideSwiperUntilUpdate) {
      this.removeAttribute('hide-swiper-until-update');
    }
  }
}

export const webcomponent = 'how-to-use';
